<template>
  <SideMenu
    ref="sideMenu"
    :heading="$lang('product_page', 'reviews')"
    :side="'right'"
    @on-side-menu-close="$emit('onProductReviewClose')"
  >
    <div class="bg-main h-full flex flex-col">
      <div class="md:px-24 px-16 overflow-y-auto mb-80">
        <client-only>
          <div
            class="yotpo yotpo-main-widget"
            :data-product-id="product.sku"
            :data-price="product.priceAsNumber"
            :data-currency="currencyCode"
            :data-name="product.title"
            :data-url="url"
            :data-image-url="product.standardImage"
          />
        </client-only>
      </div>
    </div>
  </SideMenu>
</template>

<script setup lang="ts">
import SideMenu from '~/components/navigation/SideMenu.vue';
import type Product from '~/models/product';
import type { Currencies } from '~/constants/types/cart';
import { useCartStore } from '~/store/cart';
const runtimeConfig = useRuntimeConfig();
const route = useRoute();
const cartStore = useCartStore();

const props = defineProps<{
  product: Product,
}>();

defineEmits<{
  (e: 'onProductReviewClose'): void;
}>();

const sideMenu = ref<typeof SideMenu | null>(null);
onMounted(()=> {
  if (sideMenu.value) {
    sideMenu.value.openOverlay();
  }
});

const url = computed(()=> {
  return `${runtimeConfig.public.frontendUrl}${route.fullPath}`;
});

const currencyCode = computed(()=> {
  const fallBack = props.product?.price.replace(
    /[^a-zA-Z]+/gi,
    ''
  ) as Currencies;

  return cartStore.cartData.currency || fallBack;
});

</script>

<style lang="postcss">
.side-menu {
  .yotpo.yotpo-main-widget.yotpo-small .yotpo-visible-mobile.yotpo-icon-btn-big {
    display: none !important;
  }

  .yotpo-nav.yotpo-nav-primary {
    width:300px !important;

    ul {
      width: 100% !important;
    }

    li.yotpo-nav-tab {
      width:50%;
      margin:0px;
      padding:0px;
    }

    .yotpo-dropdown-wrapper.mobile-collapse {
      width: 100% !important;
      margin-bottom: 20px;
      border-bottom: 1px solid #e3e3e3;
      position:relative;
      z-index:3000;
      .yotpo-nav-dropdown-category{
        float:left;
        width:50%!important;
        margin: 0 !important;
        padding: 15px 0 10px 0 !important;
      }
    }

    .yotpo-clr {
      @apply hidden;
    }

    .write-review-button {
      padding: 0 !important;
      padding-top: 2px !important;

      .yotpo-icon.yotpo-icon-write {
        padding-right: 0.5rem !important;
      }
    }

    .yotpo-menu-mobile-collapse.yotpo-hidden-mobile {
      @apply block;
    }

  }
  .yotpo.yotpo-main-widget.yotpo-small .yotpo-nav .yotpo-dropdown-wrapper {
    @apply w-auto;
    .yotpo-menu-mobile-collapse {
      border: none !important;
    }
  }

  .yotpo .yotpo-small-box.reviews {
    @apply border-b-0;
  }

  .yotpo-regular-box.yotpo-review, .yotpo-regular-box.yotpo-question{
    border-top:0px solid white !important;
    border-bottom: 1px solid #e3e3e3;
  }
  .yotpo-header-title {
    font-weight: bold !important;
  }
  .yotpo-grouping-reference {
    float: left;
    margin-bottom: 10px;
  }
  .grouping-reference-link, .yotpo-attribution-indicator {
    font-size: 13px;
  }

  .bottom-line-items {
    margin-bottom: 0px !important;
  }

  .new-yotpo-small-box {
    border-bottom: 0px solid white !important;
    padding-top: 40px !important;
  }

  .filters-container {
    display:none !important;
  }

  .reviews-qa-labels-container {
    display:block;
    clear:left;
  }

  .product-related-fields-item-title  {
    width:100% !important;
    text-align: center !important;
  }

  .product-related-fields-item-value  {
    width:100% !important;
    text-align: center !important;
  }

  .write-question-review-buttons-container {
    width: 100% !important;
    margin-bottom: 10px;
    text-align: center !important;
  }

  .yotpo-nav-content {
    margin-top: 30px !important;
  }

  .footer-actions {
    display: none !important;
  }

  .yotpo-grouping-reference {
    width: 100% !important;
  }

  .yotpo-nav-wrapper {
    text-transform: uppercase !important;
  }

}
</style>
